<div *ngIf="objLoaderStatus" class="bg-overlay-spinner">
  <div class="overlay">
    <img src="assets/vendor/loading.io/balls.gif" class="ld"/>
  </div>
</div>
